import {UPDATE_EXTENSION, TOGGLE_ZSTACK_SCREENSHOT, UPDATE_BARCODE_IMG_ROTATION} from "../redux_constants/screenshot.state.constant";

export const updateExtension = (extension) => ({
	type: UPDATE_EXTENSION,
	extension: extension
});

export const toggleZStackScreenshot = (zStackScreenshotEnabled) => ({
	type: TOGGLE_ZSTACK_SCREENSHOT,
	zStackScreenshotEnabled: zStackScreenshotEnabled
});

export const updateBarcodeImgRotation = (currentRotation) => ({
	type: UPDATE_BARCODE_IMG_ROTATION ,
	rotation: currentRotation
});